import type { CategoryDeleteMode } from "api/types/community-board.types";

/** 게시글 code(대분류) 슬러그 검증: 영문 소문자/숫자/언더스코어 */
export const CODE_RE = /^[a-z0-9_]+$/;

export const CODE_HELP = "영문 소문자, 숫자, 언더스코어(_)만 사용 가능합니다.";

/** 카테고리 삭제 처리 방식 옵션 */
export const CATEGORY_DELETE_MODES: { value: CategoryDeleteMode; label: string; description: string }[] = [
  {
    value: "delete_posts",
    label: "게시글 일괄 삭제",
    description: "이 카테고리에 속한 게시글을 모두 삭제합니다.",
  },
  {
    value: "move_posts",
    label: "다른 카테고리로 이동",
    description: "이 카테고리의 게시글을 선택한 카테고리로 옮긴 뒤 삭제합니다.",
  },
];
